import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { OrderWithContext } from '@/models';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgCheckoutPaymentIssueModal',
})
export default class CmgCheckoutPaymentIssueModal extends Vue {
  isSubmitting = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.checkoutPaymentIssue.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.checkoutPaymentIssue.args;
  }

  get order(): OrderWithContext | null {
    return (this.args && this.args.order) || null;
  }

  get isDelivery(): boolean {
    return !!this.args && this.args.isDelivery;
  }

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get rewardText(): string {
    return this.countryCode !== CountryCode.GB
      ? 'If you have a gift card to pay with or reward to scan, you can still use them when you pickup in restaurant today.'
      : 'If you have an offer, you can still use it when you pickup in restaurant today.';
  }

  get taxText(): string {
    return this.countryCode !== CountryCode.GB
      ? 'plus tax at pickup'
      : 'at pickup';
  }

  get formattedPrice(): string {
    if (!this.order) {
      return '';
    }

    return this.$services.utils.formatPrice(
      this.countryCode !== CountryCode.GB ? this.order.order.orderPreDiscountSubTotalAmount : this.order.order.orderTotalAmount);
  }

  onTryAgain() {
    if (!this.args) {
      return;
    }
    this.args.onTryAgain();
  }

  onClickSwitchToPayInStore() {
    if (!this.args) {
      return;
    }

    this.args.onClickSwitchToPayInStore();
  }

  onClose() {
    if (this.args && this.args.onClose) {
      this.args.onClose();
    }

    this.close();
  }

  private close() {
    this.$services.ui.setModalVisibility('checkoutPaymentIssue', false);
    this.$services.ui.focusBack();
  }
}
